<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <!----------------------------->
      <!-- Table of relationships  -->
      <!----------------------------->
      <v-flex xs12>
        <v-card>
          <v-toolbar dark dense color="primary">
            <v-toolbar-title class="title">
            <h2 class="title">Mentors</h2>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <v-btn 
                slot="activator"
                flat
                icon
                dark
                @click="downloadCSV()"
                aria-label="Download report as .csv file">
                  <v-icon aria-hidden="false">cloud_download</v-icon>
              </v-btn>
              <span >Download report as .csv file</span>
            </v-tooltip>
          </v-toolbar>
          <div ref="mentorTable"></div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  //var Tabulator = require('tabulator-tables')
  import Tabulator from 'tabulator-tables';

  export default {
    data: () => ({
      tabulator: null
    }),
    created: function() {
      //this.$store.dispatch("updateMentors")
    },
    computed: {
      mentors: function() {
        return this.$store.getters.getAllMentors
      },
      mentorsLoading: function () {
        return this.$store.getters.getMentorLoading
      }
    },
    watch: {
      mentors: function (val) {
        this.tabulator.replaceData(val)
      }
    },
    mounted() {
      this.$store.dispatch("updateMentors")

      var customMutator = function(value, data, type, params, component){
        //value - original value of the cell
        //data - the data for the row
        //type - the type of mutation occurring  (data|edit)
        //params - the mutatorParams object from the column definition
        //component - when the "type" argument is "edit", this contains the cell component for the edited cell, otherwise it is the column component for the column
        if (Array.isArray(value)) {
          return value.join(" | ")
        } else {
          return value
        }
        
      }

      //build the table
      this.tabulator = new Tabulator(this.$refs.mentorTable,
      {
        height: "500px",
        placeholder: "Please wait while the Mentors are loaded.",
        pagination: "local",
        paginationSize: 15,
        layoutColumnsOnNewData: true,
        selectable:false,
        data: this.mentors,
        columns: [
          { title: 'Name', field: 'name'},
          { title: 'Email', field: 'email'},
          { title: 'Admin', field: 'admin'},
          { title: 'Authorised', field: 'authorised'},
          { title: 'Available', field: 'available'},
          { title: 'Number of Clients', field: 'clientsCurrent'},
          { title: 'Client Limit', field: 'clientsLimit'},
          { title: 'Employer', field: 'employer'},
          { title: 'Location', field: 'location'},
          { title: 'Role', field: 'role'},
          { title: 'Specialty', field: 'specialty', mutator:customMutator},
          { title: 'Telephone', field: 'telephone'},
          { title: 'Topics', field: 'topics', mutator:customMutator},
          { title: 'Bio', field: 'bio'}
        ]
      })

    },
    methods: {
      downloadCSV() {
        var filename = "mentors.csv"
        this.tabulator.download("csv", "mentors.csv"); //download a CSV file
      }
    }
  }
</script>

<style>
  .tabulator {
    background-color: whitesmoke !important;
    font-size: 12px !important;
  }

  .tabulator .tabulator-header .tabulator-col {
    background-color: #D0D0E0 !important;
    color: navy !important;
  }

  .tabulator .tabulator-footer {
    background-color: whitesmoke !important;
    text-align: center !important;
    height: 40px !important;
  }

  .tabulator .tabulator-pages {
    color: navy !important; 
  }
  .tabulator .tabulator-page {
      color: navy !important; 
  }

</style>
